import Seo from "../components/Seo";
import { SITE } from "../config/site";

const sections = [
  {
    title: "1. What this website does",
    body: `${SITE.name} is a journey-request and matching service. The website lets passengers request a £100 fixed-fare journey between our Essex service area and London, and lets TfL-licensed London Black Cab drivers apply to receive referred journeys. Submitting a request is an enquiry only — it is not a booking and does not guarantee that a journey will be provided.`,
    review: false,
  },
  {
    title: "2. Requests, availability and confirmation",
    body: "Every journey request is reviewed manually. A contract for a journey is formed only when we contact you and expressly confirm that a driver has accepted your journey. Until you receive that confirmation you must not rely on a taxi being arranged. We may decline or be unable to fill any request, and we are not liable for losses arising from a request that is not confirmed.",
    review: true,
  },
  {
    title: "3. The fixed fare",
    body: "Confirmed journeys between the stated Essex service area and London are charged at a fixed fare of £100 in either direction. There are no additional charges, surge pricing or supplements. [LEGAL REVIEW: the operation of advance-agreed fixed fares must be checked against applicable taxi fare and taximeter regulations, and any TfL/private hire licensing requirements, before live operation.]",
    review: true,
  },
  {
    title: "4. Payment",
    body: "Passengers pay the £100 fare directly to the driver inside the licensed taxi at the end of the journey, by cash or by the driver's own card payment terminal. This website never accepts, processes or holds passenger payments, deposits or card details. The fare is agreed in advance of the journey.",
    review: false,
  },
  {
    title: "5. Who provides your journey",
    body: "Journeys are carried out either by the owner of this service (an Essex-based, TfL-licensed London Black Cab driver) or by an independent, verified Essex-based TfL Green Badge driver. Where another driver completes your journey, that driver is responsible for the carriage of passengers, and the driver's licensing and insurance apply. We will tell you when a referred driver has been assigned.",
    review: true,
  },
  {
    title: "6. Driver referral arrangements",
    body: "Drivers who complete a referred journey collect the full £100 fare from the passenger inside the cab. The commercial arrangements between the business and participating drivers are private, set out in a separate driver referral agreement, and never increase the passenger's fare.",
    review: false,
  },
  {
    title: "7. Cancellations",
    body: "Because no payment is taken in advance, there is nothing to refund. If you need to cancel a confirmed journey, please tell us as early as possible so the driver can be informed. We may cancel a confirmed journey where a driver becomes unavailable; in that case we will notify you as soon as we can, but we are not liable for consequential losses. [LEGAL REVIEW: confirm cancellation and consumer-rights wording before publication.]",
    review: true,
  },
  {
    title: "8. Passengers, luggage and conduct",
    body: "Passenger numbers (1–6) and luggage must be stated accurately on the request form and are subject to the licensed capacity of the vehicle. Drivers may refuse carriage where legal limits would be exceeded or where a passenger's conduct is unlawful or unsafe.",
    review: false,
  },
  {
    title: "9. Liability",
    body: "Nothing in these terms excludes liability that cannot be excluded by law. Otherwise, our responsibility is limited to passing your request to suitable drivers and communicating confirmations; the transport itself is provided by the assigned licensed driver. [LEGAL REVIEW: liability wording requires professional review before publication.]",
    review: true,
  },
  {
    title: "10. Changes",
    body: "We may update these terms from time to time. The version published on this page at the time of your confirmed booking applies to that journey.",
    review: false,
  },
];

export default function Terms() {
  return (
    <main data-testid="terms-page" className="mx-auto max-w-3xl px-4 py-12 sm:px-6 sm:py-20">
      <Seo
        title="Terms & Conditions"
        description="Terms covering journey requests, confirmations, the £100 fixed fare, direct passenger-to-driver payment and the driver referral structure."
      />
      <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#D4AF37]">Legal</p>
      <h1 className="mt-3 text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
        Terms &amp; Conditions
      </h1>
      <p
        data-testid="terms-draft-banner"
        className="mt-5 border border-[rgba(212,175,55,0.4)] bg-[rgba(212,175,55,0.08)] p-4 text-sm leading-relaxed text-[#D4D4D8]"
      >
        Draft terms — clauses marked [LEGAL REVIEW] must be checked by a qualified adviser
        before live operation. In particular, confirm that advance-agreed fixed fares and this
        referral structure comply with taxi fare, taximeter and licensing rules.
      </p>
      <p className="mt-4 text-sm text-[#71717A]">Last updated: [PLACEHOLDER — insert date]</p>

      <div className="mt-10 space-y-9">
        {sections.map((s) => (
          <section key={s.title}>
            <h2 className="text-xl font-semibold text-white">
              {s.title}{" "}
              {s.review && (
                <span className="ml-2 border border-[rgba(212,175,55,0.4)] px-2 py-0.5 align-middle text-[10px] font-semibold uppercase tracking-widest text-[#D4AF37]">
                  Legal review
                </span>
              )}
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-[#A1A1AA] sm:text-base">{s.body}</p>
          </section>
        ))}
      </div>
    </main>
  );
}
